import Constant from '@/const'
import { POS_KBN_LABELS } from '@/constants/posKbn'
import Store from '@/store/index.js'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import jQuery from 'jquery'
import _ from 'lodash'
import moment from 'moment'
import sanitizeHtml from 'sanitize-html'
import { ja } from 'vuejs-datepicker/dist/locale'
const $ = jQuery

const SYARYO_TYPE_KBN_JSON = {
  1: '普通車',
  2: 'トラック（4t未満）', // 昔の選択肢
  3: '大型トラック（4t以上）・バス', // 昔の選択肢
  4: '普通車', // 軽自動車
  5: 'トラック',
  6: '軽トラック',
  7: 'バス',
  9: 'その他（建機、バイクなど）',
}

const SYARYO_SHAPE_TYPE_JSON = {
  1: '平ボディ',
  2: 'PG付き',
  3: '幌付き',
  4: '箱車、ウイング車',
  5: '冷蔵冷凍車',
  6: 'ノーマル',
  7: 'キャンピングカー',
  8: 'キッチンカー',
  9: 'ダンプ',
  10: 'クレーン付',
  99: 'その他',
}

const YES_NO_FUMEI_JSON = {
  0: 'いいえ',
  1: 'はい',
  2: '不明',
}

const IS_CAR_CUSTOM_JSON = {
  0: '改造・架装なし',
  1: '改造・架装あり',
  2: '不明',
}

const CAR_CUSTOM_JSON = {
  1: 'キャリア付き',
  2: 'ローダウン',
  3: 'エアロ付き',
  4: 'オーバーフェンダー',
  5: 'リフトアップ',
  6: '福祉車両',
  99: 'その他',
}

const CAR_CONDITION_NOT_SELF_FUN_FOR_REASON_JSON = {
  1: 'バッテリー上がり（ジャンピングしてエンジンかかる）',
  2: '不動車',
  3: '事故車',
  4: '燃料切れ',
  5: 'エアコン故障・不良',
  6: 'スタッドレス未装着',
  99: 'その他',
}

const CAR_FUEL_JSON = {
  1: 'ガソリン車',
  2: 'ハイブリット車（HV）',
  3: 'PHEV（PHV）',
  4: '電気自動車（EV）',
  5: '燃料電池（FCV',
  6: 'LPG',
  7: '天然ガス車',
  8: '水素車',
  9: 'ディーゼル車',
  99: '不明',
}

const IS_EXPENSIVE_CAR_JSON = {
  0: '高額車ではない',
  1: '高額車',
  2: '不明',
}

const IS_CLASSIC_CAR_JSON = {
  0: '旧車ではない',
  1: '旧車',
  2: '不明',
}

export default {
  methods: {
    // ファイル名で使えない記号「\/:*?"<>|」を除去する。
    trimProhibitedCharactersInFileName(str) {
      let result = str
      var marks = ['\\', '/', ':', '*', '?', 'a', '<', '>', '|', ' ', '　']

      for (var i = 0; i < marks.length; i++) {
        result = result.split(marks[i]).join('')
      }
      return result
    },
    csvEscape(str) {
      if (!str || typeof str !== 'string') return str
      return str.replace(/"/g, '""')
    },
    sortStrWeek(teikyubi) {
      const week = ['月', '火', '水', '木', '金', '土', '日', '祝']
      let ret = []
      for (const w of week) {
        for (const youbi of teikyubi.split(',')) {
          if (w === youbi) {
            ret.push(w)
            break
          }
        }
      }
      return ret.join(',')
    },
    setAppCss() {
      if (this.isMobile) {
        $('.main-content .md-app').css('overflow', 'auto')
        $('.main-content .md-app').css('min-height', '450px')
      }
    },
    separateComma(num) {
      return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    getDialogStyle(val) {
      return `height:${Store.state.screen.height * val}px;`
    },
    getDialogContentStyle(val) {
      const i = this.isPC ? 0.05 : 0
      return `height:${Store.state.screen.height * (val + i) - 60}px;`
    },
    /**
     * 発注画面の選択中のタブ保持
     * @param  {[type]} hikinoName [description]
     * @param  {[type]} tabName    [description]
     * @return {[type]}            [description]
     */
    changeActiveTab(hikinoName, tabName, form) {
      if (form[`${hikinoName}_IS_MASTER_ACTIVE`] !== undefined) {
        form[`${hikinoName}_IS_MASTER_ACTIVE`] = false
      }
      if (form[`${hikinoName}_IS_AUCTION_ACTIVE`] !== undefined) {
        form[`${hikinoName}_IS_AUCTION_ACTIVE`] = false
      }
      if (form[`${hikinoName}_IS_DIRECT_ACTIVE`] !== undefined) {
        form[`${hikinoName}_IS_DIRECT_ACTIVE`] = false
      }
      if (form[`${hikinoName}_IS_FAVORITE_ACTIVE`] !== undefined) {
        form[`${hikinoName}_IS_FAVORITE_ACTIVE`] = false
      }
      if (form[`${hikinoName}_IS_SAME_ACTIVE`] !== undefined) {
        form[`${hikinoName}_IS_SAME_ACTIVE`] = false
      }
      form[`${hikinoName}_IS_${tabName}_ACTIVE`] = true
      form[`ACTIVE_${hikinoName}_TAB`] = tabName
    },
    /**
     * Get the URL parameter value
     *
     * @param  name {string} パラメータのキー文字列
     * @return  url {url} 対象のURL文字列（任意）
     */
    getUrlParam(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[[\]]/g, '\\$&')
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
      const results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    dateObjToStr(date) {
      if (!date) return
      const yearStr = date.getFullYear()
      let monthStr = 1 + date.getMonth()
      let dayStr = date.getDate()
      // let hourStr = date.getHours()
      // let minuteStr = date.getMinutes()
      // let secondStr = date.getSeconds()

      monthStr = ('0' + monthStr).slice(-2)
      dayStr = ('0' + dayStr).slice(-2)
      // hourStr = ('0' + hourStr).slice(-2)
      // minuteStr = ('0' + minuteStr).slice(-2)
      // secondStr = ('0' + secondStr).slice(-2)

      // let formatStr = 'YYYY-MM-DD hh:mm:ss'
      let formatStr = 'YYYY-MM-DD'
      formatStr = formatStr.replace(/YYYY/g, yearStr)
      formatStr = formatStr.replace(/MM/g, monthStr)
      formatStr = formatStr.replace(/DD/g, dayStr)
      // formatStr = formatStr.replace(/hh/g, hourStr)
      // formatStr = formatStr.replace(/mm/g, minuteStr)
      // formatStr = formatStr.replace(/ss/g, secondStr)
      return formatStr
    },
    getToday() {
      var now = new Date()
      return (
        now.getFullYear() +
        '-' +
        this.twoDigit(now.getMonth() + 1) +
        '-' +
        this.twoDigit(now.getDate())
      )
    },
    getNichiji() {
      var now = new Date()
      return (
        now.getFullYear() +
        '-' +
        this.twoDigit(now.getMonth() + 1) +
        '-' +
        this.twoDigit(now.getDate()) +
        ' ' +
        this.twoDigit(now.getHours()) +
        ':' +
        this.twoDigit(now.getMinutes()) +
        ':' +
        this.twoDigit(now.getSeconds())
      )
    },
    twoDigit(value) {
      return ('0' + value).slice(-2)
    },
    /**
     * タイムスタンプ文字列を年月日に変換
     * @param  {String} dateString タイムスタンプ文字列
     */
    dateFormat(dateString) {
      if (!dateString) return ''
      var tmp = dateString.split(' ')
      return tmp[0]
    },
    /**
     * タイムスタンプ文字列を年月日に変換
     * (秒なし加工、-を/に)
     * @param  {String} dateString タイムスタンプ文字列
     */
    dateFormatYmdHi(timestamp) {
      if (!timestamp) return ''
      return timestamp.substring(0, 16).replace(/-/g, '/')
    },

    /**
     * モーダル出力時に背景スクロールをロック
     * @param  {String} modalId 出力するモーダルのセレクタ
     * @param  {Boolean} isFirstModal 1つ目のモーダルか
     */
    showDialog(modalId, isFirstModal = true) {
      // iphoneの背景ロック制御
      if (this.isMobile && this.isSafari) {
        if (isFirstModal) {
          this.scrollY = window.scrollY
          $('body').css('top', `-${this.scrollY}px`)
          $('body').css('position', 'fixed')
        }
      } else {
        const modal = document.querySelector(modalId)
        disableBodyScroll(modal)
      }
    },

    /**
     * 背景スクロール制御
     * @param  string action
     */
    scroll(act) {
      if (act === 'locked') this.showDialog('.md-dialog')
      else if (act === 'clear') this.clearScrollLockAndSelectedTable()
    },

    /**
     * 背景スクロールロックを全解除
     */
    clearScrollLockAndSelectedTable() {
      clearAllBodyScrollLocks()
      if (this.isMobile && this.isSafari) {
        $('body').css('position', '')
        $('body').css('top', '')
        window.scrollTo(0, this.scrollY || 0)
      }
      this.selectedTableInitial()
    },

    /**
     * テーブル内の選択した行の色を変更する
     * @param  {JSON} item 選択した行データ
     * @return {String}      クラス名
     */
    getTableRowClass(item) {
      return this.picked && item.selected ? 'color-on' : 'color-off'
    },

    /**
     * テーブル内の選択行を設定する
     * @param {number} id   選択行ID
     * @param {array} list テーブルデータ
     */
    setTableRowClassAndName(id, list) {
      for (const item of list) {
        item.selected = false
        if (item.id === id) {
          this.picked = item.id
          item.selected = true
          this.selectedObj = item
        }
        if (item.ID === id) {
          this.picked = item.ID
          item.selected = true
          this.selectedObj = item
        }
      }
    },

    /**
     * 選択したテーブルを初期化
     */
    selectedTableInitial() {
      this.picked = null
      this.selectedObj = null
    },
    /**
     * 文字列の指定文字数以下を省略する
     * @param  {String } text   変換する文字列
     * @return {String}        省略した文字列
     */
    omitText(str, maxLength) {
      if (!str) return ''
      let moji = ''
      for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i)
        if (
          (c >= 0x0 && c < 0x81) ||
          c === 0xf8f0 ||
          (c >= 0xff61 && c < 0xffa0) ||
          (c >= 0xf8f1 && c < 0xf8f4)
        ) {
          maxLength -= 0.5
        } else {
          maxLength -= 1
        }
        if (maxLength < 0) {
          moji += '…'
          break
        } else {
          moji += str[i]
        }
      }
      return moji
    },
    _omitText(text, wari) {
      const length = Math.floor(Store.state.screen.width / wari)
      return this.omitText(text, length)
    },
    // ログイン
    async login(user) {
      await Store.dispatch('auth/login', user)
        .then((res) => {})
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    // 代理ログイン
    async proxyLogin(user) {
      await Store.dispatch('auth/proxyLogin', user).catch((err) => {
        throw new Error(err.message)
      })
    },
    /**
     * ログアウト処理
     * @return {void}
     */
    async logout() {
      const isAdminMember = this.isADMIN_MEMBER
      Store.commit('setting/destroy')
      Store.commit('vehicle/destroy')
      Store.commit('order/destroy')
      if (isAdminMember) {
        this.spinerOn()
        await Store.dispatch('auth/destroy', {
          name: 'proxy',
          proxy_user_id: Store.state.user.data.ADMIN_TANTO_ID,
        })
        Store.commit('user/destroy')
        this.spinerOff()
        window.close()
      } else {
        Store.dispatch('auth/destroy')
        Store.commit('user/destroy')
      }
      this.$router.push({ name: 'Login' })
    },
    /**
     * 指定秒停止
     * @param  {number} ms ミリ秒
     * @return {Promise}
     */
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    _alert(message, isScroll = true, callback = null) {
      Store.commit('screen/create', {
        isValid: true,
        modalMessage: message,
        isScroll,
        alertCallBack: callback,
      })
    },
    _info(message) {
      Store.commit('screen/create', { isInfo: true, modalMessage: message })
    },

    /**
     * スピナー表示
     */
    spinerOn() {
      // this.showDialog('body') // スピナー中はスクロール禁止
      Store.commit('screen/create', { isSpiner: true })
    },
    /**
     * スピナー非表示
     */
    spinerOff() {
      Store.commit('screen/create', { isSpiner: false })
    },

    /**
     * 透明フィルター表示
     */
    invisibleFilterOn() {
      Store.commit('screen/create', { isInvisibleFilter: true })
    },

    /**
     * 透明フィルター非表示
     */
    invisibleFilterOff() {
      Store.commit('screen/create', { isInvisibleFilter: false })
    },

    /**
     * スピナー表示中か判定
     * @return boolean
     */
    isSpinerDisplay() {
      return Store.state.screen.isSpiner
    },
    /**
     * 透明フィルター表示中か判定
     * @return boolean
     */
    isInvisibleFilterDisplay() {
      return Store.state.screen.isInvisibleFilter
    },
    /**
     * 端末高さがshortか判定
     * @return boolean
     */
    isShortHeight() {
      return Store.state.screen.hType === 'short'
    },
    /**
     * 選択した都道府県名を設定
     * @param {number} cityCd   都道府県コード
     * @param {String} cityName 対象都道府県パラメータ名
     * @param {object} form formオブジェクト
     */
    setPrefName(prefCd, prefName, form) {
      for (const pref of this.prefs) {
        if (pref.TODO_CD === prefCd) {
          if (form[`TODO_MEI`]) form[`TODO_MEI`] = pref.TODO_MEI
          else form[`${prefName}_TODO_MEI`] = pref.TODO_MEI
          break
        }
      }
    },
    getPrefFromId(prefCd) {
      for (const pref of this.prefs) {
        if (pref.TODO_CD === prefCd) {
          return pref
        }
      }
    },
    getPrefCdFromName(prefName) {
      for (const pref of this.prefs) {
        if (pref.TODO_MEI === prefName) {
          return pref.TODO_CD
        }
      }
    },
    /**
     * 市区町村リスト取得
     * @param String prefCd   都道府県コード
     */
    getCities(prefCd) {
      return Store.dispatch('address/getCityList', prefCd).catch(() => {
        throw new Error('市区町村の取得でシステムエラーが発生しました。')
      })
    },
    /**
     * 市区町村リスト生成
     * @param {String} prefCd   都道府県コード
     * @param {String} cityName 対象市区町村パラメータ名
     * @param {object} cities 市区町村オブジェクト
     */
    setCities(prefCd, cityName, cities) {
      cities[cityName] = []
      return Store.dispatch('address/getCityList', prefCd)
        .then((res) => {
          res.data.unshift({ SHIKU_CD: '', SHIKU_MEI: '未選択' })
          cities[cityName] = res.data
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * 選択した区町村名を設定
     * @param {number} cityCd   市区町村コード
     * @param {String} cityName 対象市区町村パラメータ名
     * @param {object} obj vueオブジェクト
     * @param {object} obj vueオブジェクトパラメータ名
     */
    setCityName(cityCd, cityName, obj, param = 'form') {
      for (const city of obj.cities[cityName]) {
        if (city.SHIKU_CD === cityCd) {
          if (obj[param][`SHIKU_MEI`]) obj[param][`SHIKU_MEI`] = city.SHIKU_MEI
          else obj[param][`${cityName}_SHIKU_MEI`] = city.SHIKU_MEI
          break
        }
      }
    },
    /**
     * 選択した区町村コードを設定
     * @param {string} cityMei   市区町村名
     * @param {string} cityName 対象市区町村パラメータ名
     * @param {object} obj vueオブジェクト
     * @param {object} obj vueオブジェクトパラメータ名
     */
    setCityCd(cityMei, cityName, obj, param = 'form') {
      for (const city of obj.cities[cityName]) {
        if (city.SHIKU_MEI === cityMei) {
          if (obj[param][`SHIKU_CD`]) obj[param][`SIKU_CD`] = city.SHIKU_CD
          else obj[param][`${cityName}_SHIKU_CD`] = city.SHIKU_CD
          break
        }
      }
    },
    getCityFromName(cityMei, cities) {
      for (const city of cities) {
        if (city.SHIKU_MEI === cityMei) {
          return city
        }
      }
    },
    getCityFromId(cityCd, cities) {
      for (const city of cities) {
        if (city.SHIKU_CD === cityCd) {
          return city
        }
      }
    },
    getCityNameFromId(cityCd, cities) {
      let cityName = ''
      for (const city of cities) {
        if (city.SHIKU_CD === cityCd) {
          cityName = city.SHIKU_MEI
          break
        }
      }
      return cityName
    },
    /**
     * 郵便番号検索
     */
    searchZipApi(zipCd) {
      return this.getAreaFromZipCd(zipCd)
        .then((res) => {
          if (!res) {
            throw new Error('存在しない郵便番号です')
          }
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * 郵便番号からエリア情報を取得
     * @param  {String} zipCd 郵便番号
     * @return {promise}       エリア情報
     */
    getAreaFromZipCd(zipCd) {
      return Store.dispatch('address/getAreaFromZipCd', zipCd)
    },
    /**
     * 住所から郵便番号を取得
     * @param  {String} address 住所
     * @return {promise}       郵便番号
     */
    getZipCd(address) {
      return Store.dispatch('address/getZipCd', address).catch((err) => {
        throw new Error(err.message)
      })
    },
    /**
     * インフォメーション取得
     */
    getInfo(data = null) {
      return Store.dispatch('info/getInfo', data)
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * アカウント取得
     */
    getAccount(data = null) {
      return Store.dispatch('account/getAccountList', data)
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * オークション会場取得
     * @param  {string} prefCd 都道府県CD
     * @param  {string} date 開催日
     */
    getAuctions(prefCd, cityCd) {
      return Store.dispatch('order/getAuctions', { prefCd, cityCd })
    },
    /**
     * 前回の発注情報取得
     * @param  {array} data
     */
    getLastJyucyu(data) {
      return Store.dispatch('order/getLastJyucyu', data)
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * 登録済みリスト
     * @param {JSON} data 検索条件
     */
    getTransports(data) {
      return Store.dispatch('order/getTransports', data).then((res) => {
        return res.data
      })
    },
    /**
     * 取引先取得
     */
    getCompany(data = null) {
      return Store.dispatch('account/getTorihikiList', data)
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * 管轄運輸支局取得
     */
    getRikujiList() {
      return Store.dispatch('order/getRikujiList')
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * 管轄運輸支局設定
     */
    getRikujiDefault(rikujiList, prefNm, cityNm) {
      for (const rikuji of rikujiList) {
        if (rikuji.KANKATSU_TODO === prefNm) {
          var kuiki = rikuji.KANKATSU_KUIKI
          kuiki = kuiki.replace(/、/g, ',')
          kuiki = kuiki.split(',')
          for (const city of kuiki) {
            if (cityNm.indexOf(city) !== -1) {
              return rikuji
            }
          }
        }
      }
    },
    /**
     * 車両メーカー一覧取得
     */
    getSyaryoMakerList() {
      return Store.dispatch('order/getSyaryoMakerList')
        .then((res) => {
          return res
        })
        .catch((err) => {
          throw new Error(err.message)
        })
    },
    /**
     * メール重複確認
     * @param {JSON} user
     */
    validEmail(id, email, role) {
      return Store.dispatch('account/validEmail', {
        ID: id,
        MAIL_ADDR: email,
        ROLE: role,
      }).catch((err) => {
        throw new Error(err.message)
      })
    },
    /**
     * 登録地域取得
     * @param {JSON} user
     */
    getNumberArea(id, email, role) {
      return Store.dispatch('order/getNumberArea').catch((err) => {
        throw new Error(err.message)
      })
    },
    /**
     * ナンバープレートお気に入り
     * @param {JSON} user
     */
    getNumberPlateOkiniiri(data) {
      return Store.dispatch('order/getNumberPlateOkiniiri', data).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // アカウント設定編集画面に出力するための自分のデータをstteに詰める
    /**
     * 料金計算
     * @param {JSON} user
     */
    calcAPI(data) {
      return Store.dispatch('trial/calc', data).catch((err) => {
        throw new Error(err.message)
      })
    },
    // アカウント設定編集画面に出力するための自分のデータをstateに詰める
    setSettingMyData() {
      const user = Store.state.user.data
      const mydata = {
        ID: user.ID,
        USER_ID: user.USER_ID,
        STATUS: user.STATUS,
        SOFU_SAKI_MEI: user.hum_torihiki.SOFU_SAKI_MEI,
        TANTO_MEI_SEI: user.TANTO_MEI_SEI,
        TANTO_MEI: user.TANTO_MEI,
        MAIL_ADDR: user.MAIL_ADDR,
        TEHAI_KANRYO_MAIL: user.TEHAI_KANRYO_MAIL,
        NOSYA_KANRYO_MAIL: user.NOSYA_KANRYO_MAIL,
        FROM_PAGE: 'SettingIndex',
      }
      Store.commit('setting/create', mydata)
    },
    // 料金カンマ区切り
    numberWithDelimiter(number) {
      if (!number) return ''
      return String(number).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    getDateTime(day) {
      const Year = day.getFullYear()
      const Month = day.getMonth() + 1
      const Date = day.getDate()
      const Hour = day.getHours()
      const Min = day.getMinutes()
      const Sec = day.getSeconds()
      const dateTime = `${Year}-${Month}-${Date} ${Hour}:${Min}:${Sec}`
      return dateTime
    },
    convAriNasiFlg(flg) {
      switch (parseInt(flg, 10)) {
        case 0:
          return 'なし'
        case 1:
          return 'あり'
        default:
          return 'なし'
      }
    },
    convYesNoFlg(flg) {
      switch (parseInt(flg, 10)) {
        case 0:
          return 'いいえ'
        case 1:
          return 'はい'
      }
    },
    convYesNoHopeFlg(flg) {
      switch (parseInt(flg, 10)) {
        case 0:
          return '希望しない'
        case 1:
          return '希望する'
        default:
          return '希望しない'
      }
    },
    convETCHopeFlg(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 0:
          return '希望しない'
        case 1:
          return '希望する（2.0）'
        case 2:
          return '希望する（その他）'
      }
    },
    convYusoKbn(kbnId) {
      switch (kbnId) {
        case Constant.YUSOKBN.YARD:
          return '輸出ヤード'
        case Constant.YUSOKBN.KOJIN:
          return '個人宅'
        case Constant.YUSOKBN.CHUKO:
          return '中販店'
      }
    },
    convYusoKbnFromHcb(kbnId) {
      switch (Number(kbnId)) {
        case Constant.YUSOKBN_HCB.YARD:
          return Constant.YUSOKBN.YARD
        case Constant.YUSOKBN_HCB.KOJIN:
          return Constant.YUSOKBN.KOJIN
        case Constant.YUSOKBN_HCB.TENPO1:
        case Constant.YUSOKBN_HCB.TENPO2:
        case Constant.YUSOKBN_HCB.TENPO3:
          return Constant.YUSOKBN.CHUKO
        default:
          return ''
      }
    },
    convYusosakiKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return 'オークションに輸送'
        case 2:
          return '店舗に輸送'
      }
    },
    convSoufusakiKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 0:
          return '送付しない'
        case 1:
          return '依頼元に送付'
      }
    },
    convNyukinJyokyoKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '入金に関わらず搬出可'
        case 2:
          return '入金済み搬出可'
        case 3:
          return '入金後搬出'
      }
    },
    convSyaryoType(typeId) {
      switch (parseInt(typeId, 10)) {
        case 1:
          return '普通車'
        case 2:
          return 'トラック(4t未満)'
        case 3:
          return '大型トラック（4t以上）・バス'
        case 9:
          return 'その他(建機, バイクなど)'
      }
    },
    convJisouKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return 'はい'
        case 2:
          return '一部可'
        case 3:
          return '不可（積載指定）'
      }
    },
    convMeihenSyakenKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '車検あり'
        case 2:
          return '車検残なし（予備検査）'
        case 3:
          return '車検残なし（保適）'
      }
    },
    convMeihenTorokuKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '新車新規'
        case 2:
          return '中古車新規'
        case 3:
          return '移転登録'
        case 4:
          return '変更登録'
      }
    },
    convMeihenNumberKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return 'ペイント'
        case 2:
          return '字光式'
        case 3:
          return '図柄入りナンバー'
      }
    },
    convMeihenKazeiKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '所有者（リース・自己所有）'
        case 2:
          return '使用者（留保）'
      }
    },
    convMeihenSyakoDaikoKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '依頼しない（取得済み）'
        case 2:
          return '車庫不要地域'
        case 3:
          return '依頼する'
      }
    },
    convMeihenJibaisekiKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return 'あり'
        case 2:
          return '加入を依頼（13ヶ月）'
        case 3:
          return '加入を依頼（25ヶ月）'
        case 4:
          return '加入を依頼（37ヶ月）'
      }
    },
    convSyakosyoJyuryoKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '書類回収済み'
        case 2:
          return 'ユーザーから書類回収希望'
      }
    },
    convSeisoKbn(kbnId) {
      switch (parseInt(kbnId, 10)) {
        case 1:
          return '洗車機'
        case 2:
          return '手洗い'
        case 10:
          return 'スタンド立寄り洗車（簡易車外と室内） 6,000円'
        case 11:
          return 'ヤード内での洗車（車外・室内） 4,000円～6,000円'
        case 12:
          return '室内清掃（ダスキン標準） 15,000円～'
        case 13:
          return '室内清掃（ダスキンスペシャル） 28,000円～'
      }
    },
    convHistoryStatus(status) {
      switch (parseInt(status, 10)) {
        case 1:
        case 2:
          return 'キャンセル'
        case 4:
          return '更新'
        case 6:
          return '引取予定日変更'
        case 7:
          return '納車予定日変更'
        case 10:
          return '納車完了日更新'
        case 11:
          return '料金変更'
        case 12:
          return '引取完了日更新'
      }
    },
    convNumberPlateFlg(flg) {
      switch (parseInt(flg, 10)) {
        case 1:
          return '利用する'
        default:
          return '利用しない'
      }
    },
    // リストから指定した値のname属性を取得
    getListName(list, val) {
      for (const item of list) {
        if (item.val === Number(val)) {
          return item.name
        }
      }
      return ''
    },
    setScreen(data) {
      Store.commit('screen/create', data)
    },
    gotoInquiry() {
      this.$router.push({ name: 'InquiryIndex' })
    },
    getHcbApiErrorMessage(messageType) {
      let errMessage = ''
      switch (messageType) {
        case 'untrust':
          errMessage =
            '<strong>貴社とのお取引状況によりご発注を受け付けることができませんでした。<br>当社担当者までお問い合わせください。</strong>'
          break
        case 'untrustEdit':
          errMessage =
            '<strong>貴社とのお取引状況によりご発注編集を受け付けることができませんでした。<br>当社担当者までお問い合わせください。</strong>'
          break
        case 'received':
          errMessage = `<strong>受付を完了したため発注内容の変更をおこなえませんでした。<br>おそれいりますが、こちらからお電話またはメールにてお問い合わせください。</strong>`
          break
        case 'other':
        default:
          errMessage =
            '<strong>システムエラーにより正常に受け付けることができませんでした。<br>恐れ入りますが当社担当者までご連絡をお願いいたします。</strong>'
          break
      }
      return errMessage
    },

    /** 一番上にあるバリデーションメッセージにスクロールする */
    async scrollToErr() {
      let height = 0
      for (var dom of $('.border-red')) {
        if (dom.innerHTML !== '') {
          height = $(dom).offset().top - 170
          break
        }
      }
      $('html').animate({
        scrollTop: height,
      })
    },

    /**
     * 値からテキストを取得
     * @param  any[] list  入力データリスト
     * @param  any val   値
     */
    getText(list, val) {
      if (!list) return null
      const data = list.filter((v) => v.value == val)
      return data.length ? data[0].text : null
    },

    /**
     * 値からデータを取得
     * @param  any[] list  入力データリスト
     * @param  any val   値
     * @param  any param 比較するパラメータ名
     */
    getParam(list, val, param = 'value') {
      if (!list) return null
      const data = list.filter((v) => v[param] == val)
      return data.length ? data[0] : null
    },

    /**
     * 見積履歴の登録
     * @param data 登録データ
     */
    addMitumoriRireki(data) {
      const rireki = _.merge(
        {
          MITUMORI_ID: data.MITUMORI_ID,
          NAIYOU: null,
          MAIL: null,
          LOGICO_FLG: 0,
          KIDOKU_FLG: null,
          KOSHIN_MEI: this.tantoMei,
        },
        data
      )
      return Store.dispatch('mitumori/addRireki', rireki)
    },

    /**
     * 改行コードを<br/>に置換してサニタイズする
     * @param text サニタイズする文字
     */
    sanitize(text) {
      return sanitizeHtml(text.replace(/\n/g, '<br/>'))
    },

    /** データが存在するか */
    isset(val) {
      return val !== undefined
    },

    /** 日 */
    dayList(year, month) {
      let result = []
      const min = 1
      if (year && month) {
        for (
          let i = min;
          i <= moment(`${year}-${month}`).endOf('month').format('D');
          i++
        ) {
          result.push(i)
        }
      }
      return result
    },

    /** stringかどうか判定する */
    isString(obj) {
      return typeof obj == 'string' || obj instanceof String
    },

    /** 空オブジェクトか判定する */
    isEmpty(obj) {
      return !Object.keys(obj).length
    },

    /**
     * 環境文字を置換する
     * @param string str 置換対象文字
     * @return string 置換後文字
     */
    replaceChar(str) {
      if (!str) return str
      const ngchr = [
        '①',
        '②',
        '③',
        '④',
        '⑤',
        '⑥',
        '⑦',
        '⑧',
        '⑨',
        '⑩',
        '⑪',
        '⑫',
        '⑬',
        '⑭',
        '⑮',
        '⑯',
        '⑰',
        '⑱',
        '⑲',
        '⑳',
        '㊤',
        '㊥',
        '㊦',
        '㊧',
        '㊨',
        'Ⅰ',
        'Ⅱ',
        'Ⅲ',
        'Ⅳ',
        'Ⅴ',
        'Ⅵ',
        'Ⅶ',
        'Ⅷ',
        'Ⅸ',
        'Ⅹ',
        'ⅰ',
        'ⅱ',
        'ⅲ',
        'ⅳ',
        'ⅴ',
        'ⅵ',
        'ⅶ',
        'ⅷ',
        'ⅸ',
        'ⅹ',
        '㍉',
        '㌔',
        '㌢',
        '㍍',
        '㌘',
        '㌧',
        '㌃',
        '㌶',
        '㍑',
        '㍗',
        '㌍',
        '㌦',
        '㌣',
        '㌫',
        '㍊',
        '㌻',
        '㎜',
        '㎝',
        '㎞',
        '㎎',
        '㎏',
        '㏄',
        '㎡',
        '№',
        '㏍',
        '℡',
        '〝',
        '〟',
        '—',
        '⁻',
        '₋',
        '㍾',
        '㍽',
        '㍼',
        '㍻',
        '㋿',
        '㈱',
        '㈲',
        '㈹',
        '髙',
        '﨑',
        '彅',
        '塚',
        '增',
        '寬',
        '敎',
        '晴',
        '朗',
        '﨔',
        '橫',
        '德',
        '瀨',
        '淸',
        '瀨',
        '凞',
        '猪',
        '益',
        '礼',
        '神',
        '祥',
        '福',
        '靖',
        '精',
        '濵',
        '琦',
        '昻',
        '緖',
        '羽',
        '薰',
        '諸',
        '賴',
        '逸',
        '郞',
        '都',
        '鄕',
        '閒',
        '隆',
        '靑',
        '飯',
        '飼',
        '館',
        '鶴',
        '黑',
        '𠮷',
      ]
      const trnchr = [
        '(1)',
        '(2)',
        '(3)',
        '(4)',
        '(5)',
        '(6)',
        '(7)',
        '(8)',
        '(9)',
        '(10)',
        '(11)',
        '(12)',
        '(13)',
        '(14)',
        '(15)',
        '(16)',
        '(17)',
        '(18)',
        '(19)',
        '(20)',
        '(上)',
        '(中)',
        '(下)',
        '(左)',
        '(右)',
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'i',
        'ii',
        'iii',
        'iv',
        'v',
        'vi',
        'vii',
        'viii',
        'ix',
        'x',
        'ミリ',
        'キロ',
        'センチ',
        'メートル',
        'グラム',
        'トン',
        'アール',
        'ヘクタール',
        'リットル',
        'ワット',
        'カロリー',
        'ドル',
        'セント',
        'パーセント',
        'ミリバール',
        'ページ',
        'mm',
        'cm',
        'km',
        'mg',
        'kg',
        'cc',
        'm2',
        'No.',
        'K.K.',
        'TEL',
        '"',
        '"',
        '-',
        '-',
        '-',
        '明治',
        '大正',
        '昭和',
        '平成',
        '令和',
        '(株)',
        '(有)',
        '(代)',
        '高',
        '崎',
        'なぎ',
        '塚',
        '増',
        '寛',
        '教',
        '晴',
        '朗',
        '欅',
        '横',
        '徳',
        '瀬',
        '清',
        '瀬',
        '煕',
        '猪',
        '益',
        '礼',
        '神',
        '祥',
        '福',
        '靖',
        '精',
        '濱',
        '埼',
        '昂',
        '緒',
        '羽',
        '薫',
        '諸',
        '頼',
        '逸',
        '郎',
        '都',
        '郷',
        '間',
        '隆',
        '青',
        '飯',
        '飼',
        '館',
        '鶴',
        '黒',
        '吉',
      ]
      for (var i = 0; i <= ngchr.length; i++) {
        str = str.replace(ngchr[i], trnchr[i], 'mg')
      }
      return str
    },

    /**
     * 全角から半角への変革関数
     * 入力値の英数記号を半角変換して返却
     * @param str
     */
    hankaku2Zenkaku(str) {
      if (!str) return str
      // 半角変換
      const halfVal = str.replace(/[！-～]/g, function (tmpStr) {
        // 文字コードをシフト
        // eslint-disable-next-line unicorn/number-literal-case
        return String.fromCharCode(tmpStr.charCodeAt(0) - 0xfee0)
      })

      // 文字コードシフトで対応できない文字の変換
      return (
        halfVal
          .replace(/”/g, '"')
          .replace(/’/g, "'")
          .replace(/‘/g, '`')
          .replace(/￥/g, '\\')
          // eslint-disable-next-line no-irregular-whitespace
          .replace(/　/g, ' ')
          .replace(/〜/g, '~')
          .replace(/ー/g, '-')
          .replace(/、/g, ',')
          .replace(/^[ -/:-@[-~]+$/g, '')
      )
    },

    /**
     * 指定日が指定曜日か判定する
     * @param  string  date
     * @param  string  weekDay
     * @return boolean
     */
    isWeekDay(date, weekDay) {
      const week = {
        日: 0,
        月: 1,
        火: 2,
        水: 3,
        木: 4,
        金: 5,
        土: 6,
      }
      return week[weekDay] === moment(date).day()
    },

    /**
     * jsonを[{text:'hoge', value:'fuga'}]に変換する
     * @param {Object} json
     * @returns
     */
    convertJsonToTextValueList(json) {
      return Object.entries(json).map(([value, text]) => ({
        text,
        value: parseInt(value),
      }))
    },
  },

  computed: {
    /**
     * 与信不可か判定する
     */
    isYoshinFuka() {
      if (!Store.state.user.data) return true
      return Number(Store.state.user.data.hum_torihiki.YOSHIN_FUKA_FLG) === 1
    },
    /**
     * 本番環境か判定
     */
    isProd() {
      return process.env.NODE_ENV === 'production'
    },
    browser() {
      let browser = ''
      const userAgent = window.navigator.userAgent.toLowerCase()
      if (
        userAgent.indexOf('msie') !== -1 ||
        userAgent.indexOf('trident') !== -1
      ) {
        browser = 'ie'
      } else if (userAgent.indexOf('edge') !== -1) {
        browser = 'edge'
      } else if (userAgent.indexOf('chrome') !== -1) {
        browser = 'chrome'
      } else if (userAgent.indexOf('safari') !== -1) {
        browser = 'safari'
      } else if (userAgent.indexOf('firefox') !== -1) {
        browser = 'firefox'
      } else if (userAgent.indexOf('opera') !== -1) {
        browser = 'opera'
      }
      return browser
    },
    isLogoOnly() {
      return Store.state.screen.isLogoOnly
    },
    isMS() {
      return this.isEdge || this.isIE
    },
    isEdge() {
      return this.browser === 'edge'
    },
    isIE() {
      return this.browser === 'ie'
    },
    isChrome() {
      return this.browser === 'chrome'
    },
    isSafari() {
      return this.browser === 'safari'
    },
    isFirefox() {
      return this.browser === 'firefox'
    },
    height() {
      return window.innerWidth
    },
    isLogin() {
      return Store.state.auth.LOGINED
    },
    /**
     * 代理ログイン中か判定
     * @return {Boolean} [description]
     */
    isADMIN_MEMBER() {
      if (!Store.state.user.data) return false
      return Store.state.user.data.ROLE === Constant.USER.ROLE.ADMIN_MEMBER
    },
    /**
     * モバイル端末の画面幅かどうか判定
     * @return {Boolean}
     */
    isMobile() {
      return this.$mq === 'sp'
    },
    /**
     * タブレット端末の画面幅かどうか判定
     * @return {Boolean}
     */
    isTablet() {
      return Store.state.screen.type === 'tablet'
    },
    /**
     * pc端末の画面幅かどうか判定
     * @return {Boolean}
     */
    isPC() {
      return this.$mq === 'pc'
    },
    /**
     * リース会社か判定
     * @return {Boolean} [description]
     */
    isLease() {
      if (!Store.state.user.data) return false
      if (!Store.state.user.data.hum_torihiki) return false
      return Number(Store.state.user.data.hum_torihiki.LEASE_KAISYA_KBN)
    },
    getKanoNichiji() {
      return [
        { val: 'いつでも', name: 'いつでも' },
        { val: 'AM', name: 'AM' },
        { val: 'PM', name: 'PM' },
      ]
    },
    getSyaryoTypeKbn() {
      return [
        { val: 1, name: '普通車' },
        { val: 2, name: 'トラック（4t未満）' },
        { val: 3, name: '大型トラック（4t以上）・バス' },
        { val: 9, name: 'その他（建機、バイクなど）' },
      ]
    },
    getJisouKbn() {
      return [
        { val: 1, name: 'はい' },
        { val: 2, name: '一部可' },
        { val: 3, name: '不可（積載指定）' },
      ]
    },
    getTrialSeisouFlg() {
      return [
        { val: 1, name: '洗車機' },
        { val: 2, name: '手洗い' },
        { val: 10, name: 'スタンド立寄り洗車（簡易車外と室内） 6,000円' },
        { val: 11, name: 'ヤード内での洗車（車外・室内） 4,000円～6,000円' },
        { val: 12, name: '室内清掃（ダスキン標準） 15,000円～' },
        { val: 13, name: '室内清掃（ダスキンスペシャル） 28,000円～' },
      ]
    },
    getYusoKbn() {
      return [
        { val: Constant.YUSOKBN.YARD, name: '輸出ヤード' },
        { val: Constant.YUSOKBN.KOJIN, name: '個人宅' },
        { val: Constant.YUSOKBN.CHUKO, name: '中販店' },
      ]
    },
    getAriNasiFlg() {
      return [
        { val: 0, name: 'なし' },
        { val: 1, name: 'あり' },
      ]
    },
    getYesNoFlg() {
      return [
        { val: 0, name: 'いいえ' },
        { val: 1, name: 'はい' },
      ]
    },
    getYesNoHopeFlg() {
      return [
        { val: 0, name: '希望しない' },
        { val: 1, name: '希望する' },
      ]
    },

    /** 自賠責 */
    jibaisekiList() {
      return [
        { value: '', text: '未選択' },
        { value: 1, text: 'あり' },
        { value: 2, text: '加入を依頼（13ヶ月）' },
        { value: 3, text: '加入を依頼（25ヶ月）' },
        { value: 4, text: '加入を依頼（37ヶ月）' },
      ]
    },

    /** ETC車載器セットアップのご希望 */
    etcHopeList() {
      return [
        { value: 0, text: '希望しない' },
        { value: 1, text: '希望する（2.0）' },
        { value: 2, text: '希望する（その他）' },
      ]
    },

    /** 車庫証明取得代行 */
    syakoDaikoList() {
      return [
        { value: 1, text: '依頼しない（取得済み）' },
        { value: 2, text: '車庫不要地域' },
        { value: 3, text: '依頼する' },
      ]
    },

    /** 課税対象 */
    kazeiList() {
      return [
        { value: '', text: '未選択' },
        { value: 1, text: '所有者（リース・自己所有）' },
        { value: 2, text: '使用者（留保）' },
      ]
    },

    /** ナンバー種別 */
    numberKbnList() {
      return [
        { value: '', text: '未選択' },
        { value: 1, text: 'ペイント' },
        { value: 2, text: '字光式' },
        { value: 3, text: '図柄入りナンバー' },
      ]
    },

    /** 登録種別 */
    torokuKbnList() {
      return [
        { value: 1, text: '新車新規' },
        { value: 2, text: '中古車新規' },
        { value: 3, text: '移転登録' },
        { value: 4, text: '変更登録' },
      ]
    },

    /** 車検 */
    syakenList() {
      return [
        { value: 1, text: '車検あり' },
        { value: 2, text: '車検残なし（予備検査）' },
        { value: 3, text: '車検残なし（保適）' },
      ]
    },

    /** 書類の送付先 */
    docSoufusakiList() {
      return [
        { value: 0, text: '送付しない' },
        { value: 1, text: '依頼元に送付' },
      ]
    },

    /** 書類の送付物 */
    docSoufubutuList() {
      return [
        { value: 0, text: '送付しない' },
        { value: 1, text: '車検証送付' },
        { value: 2, text: 'ナンバープレート・車検証送付' },
      ]
    },

    /** 輸送先 */
    yusosakiList() {
      return [
        { value: 1, text: 'オークションに輸送' },
        { value: 2, text: '店舗に輸送' },
        { value: 9, text: 'その他' },
      ]
    },

    /** 法人輸送先 */
    yusosakiLeaseList() {
      return [
        { value: 3, text: 'ヤード' },
        { value: 9, text: 'その他' },
      ]
    },

    /** 入金状況 */
    aaNyukinJyokyoKbnList() {
      return [
        { value: '', text: '未選択' },
        { value: 1, text: '入金に関わらず搬出可' },
        { value: 2, text: '入金済み搬出可' },
        { value: 3, text: '入金後搬出' },
      ]
    },

    /** 車両タイプ JSON */
    syaryoTypeKbnJson() {
      return SYARYO_TYPE_KBN_JSON
    },

    /** 車両タイプ TextValueList */
    syaryoTypeKbnList() {
      return this.convertJsonToTextValueList(this.syaryoTypeKbnJson).filter(
        (item) => ![2, 3, 4].includes(item.value)
      )
    },

    /** AM・PM */
    ampmList() {
      return [
        { value: '', text: '未選択' },
        { value: 'AM', text: 'AM' },
        { value: 'PM', text: 'PM' },
      ]
    },

    /** 輸送区分 */
    yusoKbnList() {
      return [
        { value: '', text: '未選択' },
        { value: Constant.YUSOKBN.YARD, text: '輸出ヤード' },
        { value: Constant.YUSOKBN.KOJIN, text: '個人宅' },
        { value: Constant.YUSOKBN.CHUKO, text: '中販店' },
      ]
    },

    /** 自走区分 */
    jisouKbnList() {
      return [
        { value: 1, text: 'はい' },
        { value: 2, text: '一部可' },
        { value: 3, text: '不可（積載指定）' },
      ]
    },

    /** 見積り経路一覧 */
    routeList() {
      return [
        { value: '', text: '未選択' },
        { text: 'ロジNAVI', value: 'loginavi' },
        { text: '社内', value: 'logico' },
      ]
    },

    /** ステータス一覧 */
    statusList() {
      return [
        { value: '', text: '未選択' },
        { text: '見積依頼', value: 1, color: 'bg-warning' },
        { text: '対応中', value: 2, color: 'bg-success text-white' },
        { text: '回答済み', value: 3 },
        { text: '発注済み', value: 4 },
        { text: '未問合せ', value: 5 },
      ]
    },

    /** POS種別一覧 */
    posKbnList() {
      return this.convertJsonToTextValueList(POS_KBN_LABELS)
    },

    /** あり・なし */
    ariNasiList() {
      return [
        { value: 0, text: 'なし' },
        { value: 1, text: 'あり' },
      ]
    },

    /** はい・いいえ */
    yesNoList() {
      return [
        { text: 'いいえ', value: 0 },
        { text: 'はい', value: 1 },
      ]
    },

    /** はい・いいえ */
    yesNoListDesc() {
      return [
        { text: 'はい', value: 1 },
        { text: 'いいえ', value: 0 },
      ]
    },

    /** はい・いいえ・不明 JSON */
    yesNoFumeiJson() {
      return YES_NO_FUMEI_JSON
    },

    /** いいえ・はい・不明 TextValueList*/
    yesNoFumeiList() {
      return this.convertJsonToTextValueList(this.yesNoFumeiJson)
    },

    /** はい・いいえ・不明 TextValueList */
    yesNoFumeiListDesc() {
      const list = this.convertJsonToTextValueList(this.yesNoFumeiJson)

      return [
        list.find((item) => item.value === 1),
        list.find((item) => item.value === 0),
        list.find((item) => item.value === 2),
      ]
    },

    /** 希望する・希望しない */
    yesNoHopeList() {
      return [
        { text: '希望しない', value: 0 },
        { text: '希望する', value: 1 },
      ]
    },

    /** 清掃サービス */
    seisoList() {
      return [
        { value: '', text: '未選択' },
        { text: '洗車機', value: 1 },
        { text: '手洗い', value: 2 },
        { text: 'スタンド立寄り洗車（簡易車外と室内）', value: 10 },
        { text: 'ヤード内での洗車（車外・室内）', value: 11 },
        { text: '室内清掃（ダスキン標準） 15,000円～', value: 12 },
        { text: '室内清掃（ダスキンスペシャル） 28,000円～', value: 13 },
      ]
    },

    /** 自走区分 */
    jisoList() {
      return [
        { value: '', text: '未選択' },
        { text: 'はい', value: 1 },
        { text: '一部可', value: 2 },
        { text: '不可（積載指定）', value: 3 },
      ]
    },

    /** 車種 */
    carTypeList() {
      return [
        { value: '', text: '未選択' },
        { text: '普通車', value: 1 },
        { text: 'トラック(4t未満)', value: 2 },
        { text: '大型トラック（4t以上）・バス', value: 3 },
        { text: '軽自動車', value: 4 },
        { text: 'その他(建機, バイクなど)', value: 9 },
      ]
    },

    /** 車両ステータス */
    syaryoStatus() {
      return [
        { text: 1, value: '調整中' },
        { text: 2, value: '手配完了' },
        { text: 3, value: '引取完了' },
        { text: 4, value: '納車完了' },
        { text: 5, value: '受注完了' },
        { text: 9, value: 'キャンセル' },
      ]
    },

    /** 車庫証明申請書類 */
    syakosyoJyuryoKbn() {
      return [
        { value: 1, text: '書類回収済み' },
        { value: 2, text: 'ユーザーから書類回収希望' },
      ]
    },

    /** 車庫承諾書の取寄せ先 */
    syakoSyodakusyoToriyoseList() {
      return [
        { value: 0, text: '未選択' },
        { value: 1, text: '新使用者' },
        { value: 2, text: '管理会社' },
      ]
    },

    /** 車両形状 JSON */
    syaryoShapeTypeJson() {
      return SYARYO_SHAPE_TYPE_JSON
    },

    /** 車両形状 TextValueList */
    syaryoShapeTypeList() {
      return this.convertJsonToTextValueList(this.syaryoShapeTypeJson)
    },

    /** 車両状態(自走できない理由) JSON */
    carConditionNotSelfRunForReasonJson() {
      return CAR_CONDITION_NOT_SELF_FUN_FOR_REASON_JSON
    },

    /** 車両状態(自走できない理由) TextValueList */
    carConditionNotSelfRunForReasonList() {
      return this.convertJsonToTextValueList(
        this.carConditionNotSelfRunForReasonJson
      )
    },

    /** 車両改造か JSON */
    isCarCustomJson() {
      return IS_CAR_CUSTOM_JSON
    },

    /** 車両改造か TextValueList */
    isCarCustomList() {
      return this.convertJsonToTextValueList(this.isCarCustomJson)
    },

    /** 車両改造 JSON */
    carCustomJson() {
      return CAR_CUSTOM_JSON
    },

    /** 車両改造 TextValueList */
    carCustomList() {
      return this.convertJsonToTextValueList(this.carCustomJson)
    },

    /** 車両燃料 JSON */
    carFuelJson() {
      return CAR_FUEL_JSON
    },

    /** 車両燃料 TextValueList */
    carFuelList() {
      return this.convertJsonToTextValueList(this.carFuelJson)
    },

    /** 高額車両か JSON */
    isExpensiveCarJson() {
      return IS_EXPENSIVE_CAR_JSON
    },

    /** 高額車両か TextValueList */
    isExpensiveCarList() {
      return this.convertJsonToTextValueList(this.isExpensiveCarJson)
    },

    /** 旧車か JSON */
    isClassicCarJson() {
      return IS_CLASSIC_CAR_JSON
    },

    /** 旧車か TextValueList */
    isClassicCarList() {
      return this.convertJsonToTextValueList(this.isClassicCarJson)
    },

    /** 年代 */
    yearList() {
      let result = [{ value: null, text: '未選択' }]
      const min = 1940
      for (let i = min; i <= moment().format('Y'); i++) {
        result.push(i)
      }
      return result
    },

    /** 月 */
    monthList() {
      let result = []
      const min = 1
      for (let i = min; i <= 12; i++) {
        result.push(i)
      }
      return result
    },

    /** Datepickerがあるブラウザか判定 */
    isEnableDatepicker() {
      return (
        this.isChrome ||
        this.isEdge ||
        this.isFirefox ||
        (this.isMobile && this.isSafari)
      )
    },

    /** ログイン担当者を返却 */
    tanto() {
      return Store.state.user.data
    },

    /** ログイン担当者名を取得 */
    tantoMei() {
      return `${this.tanto.TANTO_MEI_SEI} ${this.tanto.TANTO_MEI || ''}`
    },

    /** 取引先を返却 */
    torihikiSaki() {
      return this.tanto.hum_torihiki
    },
  },
  data: () => ({
    datePickerFormat: 'yyyy/MM/dd',
    ja,
    scrollY: 0, // モーダル表示時点のスクロール位置
    // テーブル一覧選択
    selectedObj: null,
    picked: null, // ラジオボタンのチェックしてるやつ
    // 都道府県
    prefs: [
      { TODO_CD: '', TODO_MEI: '未選択' },
      { TODO_CD: '01', TODO_MEI: '北海道' },
      { TODO_CD: '02', TODO_MEI: '青森県' },
      { TODO_CD: '03', TODO_MEI: '岩手県' },
      { TODO_CD: '04', TODO_MEI: '宮城県' },
      { TODO_CD: '05', TODO_MEI: '秋田県' },
      { TODO_CD: '06', TODO_MEI: '山形県' },
      { TODO_CD: '07', TODO_MEI: '福島県' },
      { TODO_CD: '08', TODO_MEI: '茨城県' },
      { TODO_CD: '09', TODO_MEI: '栃木県' },
      { TODO_CD: '10', TODO_MEI: '群馬県' },
      { TODO_CD: '11', TODO_MEI: '埼玉県' },
      { TODO_CD: '12', TODO_MEI: '千葉県' },
      { TODO_CD: '13', TODO_MEI: '東京都' },
      { TODO_CD: '14', TODO_MEI: '神奈川県' },
      { TODO_CD: '15', TODO_MEI: '新潟県' },
      { TODO_CD: '16', TODO_MEI: '富山県' },
      { TODO_CD: '17', TODO_MEI: '石川県' },
      { TODO_CD: '18', TODO_MEI: '福井県' },
      { TODO_CD: '19', TODO_MEI: '山梨県' },
      { TODO_CD: '20', TODO_MEI: '長野県' },
      { TODO_CD: '21', TODO_MEI: '岐阜県' },
      { TODO_CD: '22', TODO_MEI: '静岡県' },
      { TODO_CD: '23', TODO_MEI: '愛知県' },
      { TODO_CD: '24', TODO_MEI: '三重県' },
      { TODO_CD: '25', TODO_MEI: '滋賀県' },
      { TODO_CD: '26', TODO_MEI: '京都府' },
      { TODO_CD: '27', TODO_MEI: '大阪府' },
      { TODO_CD: '28', TODO_MEI: '兵庫県' },
      { TODO_CD: '29', TODO_MEI: '奈良県' },
      { TODO_CD: '30', TODO_MEI: '和歌山県' },
      { TODO_CD: '31', TODO_MEI: '鳥取県' },
      { TODO_CD: '32', TODO_MEI: '島根県' },
      { TODO_CD: '33', TODO_MEI: '岡山県' },
      { TODO_CD: '34', TODO_MEI: '広島県' },
      { TODO_CD: '35', TODO_MEI: '山口県' },
      { TODO_CD: '36', TODO_MEI: '徳島県' },
      { TODO_CD: '37', TODO_MEI: '香川県' },
      { TODO_CD: '38', TODO_MEI: '愛媛県' },
      { TODO_CD: '39', TODO_MEI: '高知県' },
      { TODO_CD: '40', TODO_MEI: '福岡県' },
      { TODO_CD: '41', TODO_MEI: '佐賀県' },
      { TODO_CD: '42', TODO_MEI: '長崎県' },
      { TODO_CD: '43', TODO_MEI: '熊本県' },
      { TODO_CD: '44', TODO_MEI: '大分県' },
      { TODO_CD: '45', TODO_MEI: '宮崎県' },
      { TODO_CD: '46', TODO_MEI: '鹿児島県' },
      { TODO_CD: '47', TODO_MEI: '沖縄県' },
    ],
    prefList: [
      { value: null, text: '未選択' },
      { value: '01', text: '北海道' },
      { value: '02', text: '青森県' },
      { value: '03', text: '岩手県' },
      { value: '04', text: '宮城県' },
      { value: '05', text: '秋田県' },
      { value: '06', text: '山形県' },
      { value: '07', text: '福島県' },
      { value: '08', text: '茨城県' },
      { value: '09', text: '栃木県' },
      { value: '10', text: '群馬県' },
      { value: '11', text: '埼玉県' },
      { value: '12', text: '千葉県' },
      { value: '13', text: '東京都' },
      { value: '14', text: '神奈川県' },
      { value: '15', text: '新潟県' },
      { value: '16', text: '富山県' },
      { value: '17', text: '石川県' },
      { value: '18', text: '福井県' },
      { value: '19', text: '山梨県' },
      { value: '20', text: '長野県' },
      { value: '21', text: '岐阜県' },
      { value: '22', text: '静岡県' },
      { value: '23', text: '愛知県' },
      { value: '24', text: '三重県' },
      { value: '25', text: '滋賀県' },
      { value: '26', text: '京都府' },
      { value: '27', text: '大阪府' },
      { value: '28', text: '兵庫県' },
      { value: '29', text: '奈良県' },
      { value: '30', text: '和歌山県' },
      { value: '31', text: '鳥取県' },
      { value: '32', text: '島根県' },
      { value: '33', text: '岡山県' },
      { value: '34', text: '広島県' },
      { value: '35', text: '山口県' },
      { value: '36', text: '徳島県' },
      { value: '37', text: '香川県' },
      { value: '38', text: '愛媛県' },
      { value: '39', text: '高知県' },
      { value: '40', text: '福岡県' },
      { value: '41', text: '佐賀県' },
      { value: '42', text: '長崎県' },
      { value: '43', text: '熊本県' },
      { value: '44', text: '大分県' },
      { value: '45', text: '宮崎県' },
      { value: '46', text: '鹿児島県' },
      { value: '47', text: '沖縄県' },
    ],
    time: [
      '0:00',
      '0:30',
      '1:00',
      '1:30',
      '2:00',
      '2:30',
      '3:00',
      '3:30',
      '4:00',
      '4:30',
      '5:00',
      '5:30',
      '6:00',
      '6:30',
      '7:00',
      '7:30',
      '8:00',
      '8:30',
      '9:00',
      '9:30',
      '10:00',
      '10:30',
      '11:00',
      '11:30',
      '12:00',
      '12:30',
      '13:00',
      '13:30',
      '14:00',
      '14:30',
      '15:00',
      '15:30',
      '16:00',
      '16:30',
      '17:00',
      '17:30',
      '18:00',
      '18:30',
      '19:00',
      '19:30',
      '20:00',
      '20:30',
      '21:00',
      '21:30',
      '22:00',
      '22:30',
      '23:00',
      '23:30',
    ],
    accountStatus: {
      initial: '未アクティベート',
      activated: 'アクティベート済',
      changeid: 'メールアドレス変更中',
      restrict: '使用不可',
    },
  }),
}



// WEBPACK FOOTER //
// ./src/components/mixin/Mixin.js